import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const MinusIcon = (props: SvgIconProps) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <rect x="4" y="9.10938" width="12" height="2" rx="1" />
  </SvgIcon>
);

export default MinusIcon;
